// extracted by mini-css-extract-plugin
export default {"root":"MoreButton_root__iHIi0","content":"MoreButton_content__VFIBn","text":"MoreButton_text__Kjzp0"};